'use client'

import React from 'react'

import { Box, HTMLChakraProps } from '@chakra-ui/react'

import { ColorScheme, sideNavContainerStyles } from './SideNavItem.styles'

export type SideNavContainerProps = HTMLChakraProps<'div'> & {
  isOpen: boolean
  colorScheme?: ColorScheme
}

export const SideNavContainer = ({
  isOpen,
  colorScheme = 'dark',
  children,
  ...rest
}: SideNavContainerProps) => (
  <Box {...sideNavContainerStyles(isOpen, colorScheme)} {...rest}>
    {children}
  </Box>
)
